<template>
  <SogCard>
    <SogCardTitle>
      {{ props.orderHead.orderNumber }}
    </SogCardTitle>
    <slot />
    <SogCardContent>
      <OrderHeadComponent
        :order-head="orderHead"
        :payment="payment"
      />
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import OrderHead from "@/shared/model/orderHead";
import OrderHeadComponent from "@/modules/Order/components/OrderHeadComponent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Payment from "@/shared/model/Payment";

interface Props {
  orderHead?: OrderHead
  payment?: Payment
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    orderHead: undefined,
    payment: undefined

  }
)


</script>

<style scoped>
</style>
